import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import ClusterMetricsCards from '../ClusterMetricsCards';
import MemoryUtilizationCard from '../MemoryUtilizationCard';
import NodesList from '../NodesList';
import SessionHealthCard from '../SessionHealthCard';
import SessionsTab from '../sessions-tab';
import { ClusterOptimizerTabsProps } from '../types';

const ClusterOptimizerTabs: React.FC<ClusterOptimizerTabsProps> = ({
  nodePodsMap,
  nodeMetrics,
  podMetrics,
  podSessionMap,
  clusterMetrics,
  sessionStats,
  expandedNodes,
  showGatewayNodes,
  showNormalNodes,
  isLoading,
  isLoadingSessions,
  error,
  sessions,
  toggleNode,
  setShowGatewayNodes,
  setShowNormalNodes
}) => {
  return (
    <Tabs defaultValue="overview" className="space-y-6">
      <TabsList>
        <TabsTrigger value="overview">Overview</TabsTrigger>
        <TabsTrigger value="nodes">Nodes & Pods</TabsTrigger>
        <TabsTrigger value="sessions">Sessions</TabsTrigger>
      </TabsList>
      
      {/* Overview Tab Content */}
      <TabsContent value="overview" className="space-y-6">
        <ClusterMetricsCards
          clusterMetrics={clusterMetrics}
          sessionStats={sessionStats}
          isLoading={isLoading}
          isLoadingSessions={isLoadingSessions}
        />
        
        <MemoryUtilizationCard
          clusterMetrics={clusterMetrics}
          isLoading={isLoading}
          showGatewayNodes={showGatewayNodes}
          showNormalNodes={showNormalNodes}
        />
        
        <SessionHealthCard
          sessionStats={sessionStats}
          isLoadingSessions={isLoadingSessions}
        />
      </TabsContent>
      
      {/* Nodes Tab Content */}
      <TabsContent value="nodes">
        <NodesList
          nodePodsMap={nodePodsMap}
          nodeMetrics={nodeMetrics}
          podMetrics={podMetrics}
          podSessionMap={podSessionMap}
          isLoading={isLoading}
          isLoadingSessions={isLoadingSessions}
          error={error}
          expandedNodes={expandedNodes}
          showGatewayNodes={showGatewayNodes}
          showNormalNodes={showNormalNodes}
          toggleNode={toggleNode}
          setShowGatewayNodes={setShowGatewayNodes}
          setShowNormalNodes={setShowNormalNodes}
        />
      </TabsContent>
      
      {/* Sessions Tab Content */}
      <TabsContent value="sessions">
        <SessionsTab
          sessions={sessions}
          sessionStats={sessionStats}
          isLoadingSessions={isLoadingSessions}
        />
      </TabsContent>
    </Tabs>
  );
};

export default ClusterOptimizerTabs; 